export default __webpack_public_path__ + "bc31f176483f0cc53d5649d434e18d44.png";